import {getEnvironment} from "../../../lib/get-environment";

const LAWPAY_CONFIG_DEV = {
    client_id: '6200fb617effc293d6a1a89a9af60c47771cb810f9347708c3b969a773ae737c',
    redirect_uri: 'http://localhost:8000/lawpayauth/callback'
};

const LAWPAY_CONFIG_DEMO = {
    client_id: 'd9ac5917a2b198927357a9e5ed679a41bb5d48d74be3a0ea5255be0c1c25217c',
    redirect_uri: 'https://api-demo.outlawpractice.com/lawpayauth/callback'
};

const LAWPAY_CONFIG_TEST = {
    client_id: '2ecd16153c974a038b542431b3621765f5d96e89e927eb73ab93f5e3467b5c41',
    redirect_uri: 'https://api.outlawpractice.dev/lawpayauth/callback'
};

const LAWPAY_CONFIG_BETA = {
    client_id: 'a2b7879c858e6a7323ff179ddc0cfaa6f0388ab6943fe6e9a989ce375afcb950',
    redirect_uri: 'https://api-beta.outlawpractice.com/lawpayauth/callback'
};

const LAWPAY_CONFIG_PROD = {
    client_id: '3502fb028cce304121f8f010b7e6455974d2bc4aa5a41c5069fc6563a3cc2de8',
    redirect_uri: 'https://api.outlawpractice.com/lawpayauth/callback'
};

let LAWPAY_CONFIG = null;

switch(getEnvironment()) {
    case 'P':
        LAWPAY_CONFIG = LAWPAY_CONFIG_PROD;
        break;
    case 'B':
        LAWPAY_CONFIG = LAWPAY_CONFIG_BETA;
        break;
    case 'DM':
        LAWPAY_CONFIG = LAWPAY_CONFIG_DEMO;
        break;
    case 'T':
        LAWPAY_CONFIG = LAWPAY_CONFIG_TEST;
        break;
    default:
        LAWPAY_CONFIG = LAWPAY_CONFIG_DEV;
}

export default LAWPAY_CONFIG;
